export default "__VITE_ASSET__DN59$gnx__"